import { updateSavedItems } from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";

type PublicUpdateSavedItemsMethod = (params: {
  itemId: string;
  variantId: number;
}) => Promise<void>;
type UpdateSavedItemsMethod = SavedItemsSdkMethod<PublicUpdateSavedItemsMethod>;

export const updateSavedItemsInitializer: UpdateSavedItemsMethod =
  ({ getAuthHeaderPredicate, ...context }) =>
  async ({ itemId, variantId }) => {
    try {
      const response = await updateSavedItems({
        itemId,
        variantId,
        authHeader: await getAuthHeaderPredicate(),
        chameleonRequestInstance: context.chameleonRequestInstance,
        store: context.store,
        keyStoreDataversion: context.keyStoreDataversion,
        shop: context.shop,
        lang: context.lang,
        sizeSchema: context.sizeSchema,
        country: context.country,
        currency: context.currency,
      });

      return response;
    } catch (error) {
      console.error("Error updating saved items:", error);
      throw error;
    }
  };
